import { Geek, GeekItem, GeekJobInfo } from './geek.model';
import { Localization } from './localization.enum';
import {
  Opportunity,
  OpportunityItemStatus,
  OpportunityItemOtherStatus,
  OpportunityMembershipStatus,
  OpportunityDraft,
} from './opportunities';
import { Level } from './opportunities/level.enum';
import { PendingUser } from './user.model';

export const Empty = {
  geek: {
    id: '',
    firstName: '',
    lastName: '',
    gCoins: 0,
    isSuperAdmin: false,
    isAdmin: false,
    isGCoinsManager: false,
    avatarUrl: '',
    permissions: [],
    localization: Localization.Poland,
    isActive: true,
  } as Geek,

  geekItem: {
    id: '',
    firstName: '',
    lastName: '',
    nick: '',
  } as GeekItem,

  opportunity: {
    createdAt: '',
    department: '',
    endDate: '',
    expectedOutput: '',
    gCoinsAward: 0,
    gxpAward: 0,
    id: '',
    issuer: {
      id: '',
      avatarUrl: '',
      firstName: '',
      lastName: '',
      nick: '',
      isActive: true,
    },
    level: Level.Medium,
    longDescription: '',
    rejectionReason: '',
    deletionReason: '',
    summary: '',
    selfMembershipStatus: OpportunityMembershipStatus.None,
    subject: '',
    shortDescription: '',
    startDate: '',
    status: OpportunityItemStatus.Pending,
    tags: [],
    vacancies: 0,
    members: [],
    messages: [],
  } as Opportunity,

  opportunityDraft: {
    createdAt: '',
    department: '',
    endDate: '',
    expectedOutput: '',
    gCoinsAward: 0,
    gxpAward: 0,
    id: '',
    issuer: {
      id: '',
      avatarUrl: '',
      firstName: '',
      lastName: '',
      nick: '',
      isActive: true,
    },
    level: Level.Medium,
    longDescription: '',
    subject: '',
    shortDescription: '',
    startDate: '',
    status: OpportunityItemOtherStatus.Draft,
    tags: [],
    vacancies: 0,
  } as OpportunityDraft,

  pendingUser: {
    id: '',
    createdAt: '',
    firstName: '',
    lastName: '',
  } as PendingUser,

  geekJobInfo: {
    department: '',
    location: '',
    designation: '',
    practice: '',
  } as GeekJobInfo,
};
